export const environment = {
  production: false,
  baseImageUrl: '',
  baseHref: '/',
  appName: 'Cast Measurements',
  appShortName: 'Cast Measurements',
  appVersion: '1.0.14',
  authApiUrl: 'api',
  authzValidatorConfig: {
    myIdBaseUrl: 'auth/login/CAST-MEAS-LOCAL'
  },
  hostname: 'https://latest.cmeasure.wdprapps.disney.com',
  clientId: 'CAST-MEAS-LOCAL',
  sessionExp: 300000, // in milliseconds (15 minutes)
  sessionTimeOut: 25, // in minutes (25 minutes)
};
